import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ProjectPage from 'pages/ProjectPage';
import NotFoundPage from 'pages/NotFoundPage';
import TeamPage from 'pages/TeamPage';

import { ProjectDetailPage } from 'pages/ProjectDetailPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';
import TermsPage from 'pages/TermsPage';
import PrivacyPage from 'pages/PrivacyPage';
import AboutPage from 'pages/AboutPage';
import DonatePage from 'pages/DonatePage';

import './assets/css/styles.css';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <Routes>
      <Route exact path="/" element={<LandingPage />} />
      <Route exact path="/about" element={<AboutPage />} />
      <Route path="/programs" element={<ProjectPage />} />
      <Route exact path="/programs/:id" element={<ProjectDetailPage />} />
      <Route exact path="/team" element={<TeamPage />} />
      <Route exact path="/get-involved" element={<DiscussProjectPage />} />
      <Route exact path="/donate" element={<DonatePage />} />
      <Route exact path="/terms" element={<TermsPage />} />
      <Route exact path="/privacy" element={<PrivacyPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
